<template>
<div class="container">
    <div class="card">
        <div style="height: 16px;"></div>
        <div class="tip-minor">注意：未成年用户无法使用小号交易系统</div>
        <div class="subtitle">卖家须知（出售）</div>
        <ul class="list">
            <li>消费0元、未开放交易的游戏、停服/停运、角色违规封禁的游戏小号无法出售；具体以出售页面显示为准。</li>
            <li>商品提交审核后，小号将被冻结无法登录；因等待造成的登录中断、道具及奖励流失，平台不具备赔偿责任。</li>
            <li>为确保信息真实，审核时可能对截图、描述进行修改或删除，以游戏内实际信息为准。</li>
            <li>审核及出售中时，可随时修改商品售价，修改后将重新进入审核期</li>
            <li>小号出售成功后，该小号下所有区服角色将会一并出售。</li>
            <li>交易成功收取5%手续费（最低5元），剩余收益以赠送余额发放，<span class="warn">不支持提现</span>。</li>
            <li>交易完成后，小号不支持找回。</li>
            <li>出售中账号一个月内未售出，系统将自动下架。</li>
            <li>使用虚假信息、截图作假、封禁角色等违规出售，将面临封号处理。</li>
            <li>因账号保管不当、共享泄露导致被盗售，平台不承担赔偿责任。</li>
            <li>本功能仅限小号交易，切勿违规转移，产生问题平台概不负责。</li>
            <li>系统实时监控数据，异常账号（批量倒卖、转移余额等）将直接封号。</li>
        </ul>

        <div class="subtitle">买家须知（购买）</div>
        <ul class="list">
            <li>角色信息已通过官方审验，因时间导致排行榜、称号、装备变化，不视为信息失实。</li>
            <li>购买后小号自动转入当前账号，重新登录游戏选择使用对应小号。</li>
            <li>本系统仅为小号转移，不涉及账号交易或换绑，无找回风险。</li>
            <li class="warn">购买前请先下载游戏，确认设备/系统可正常进入。</li>
            <li>购买成功后如遇游戏停服/停运，平台不承担赔偿责任。</li>
            <li>交易完成后，<span class="warn">非小号交易问题不支持退货退款</span>。</li>
            <li>请勿私下交易，私下交易被骗、找回等问题平台不予处理。</li>
            <li>交易完成后如遇问题，请在24小时内联系客服处理。</li>
        </ul>
        <!-- <div class="footer">小号交易规则</div> -->
    </div>
</div>
</template>
<script>
import { useRouter } from "vue-router";
export default {
  setup() {
    const router = useRouter();
    const onClickLeft = () => {
      router.go(-1);
    };
    return {
      onClickLeft,
    };
  },
};
</script>

<style scoped>
 * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }

        body {
            background-color: #ffffff;
            padding: 15px;
            color: #333;
            line-height: 1.65;
        }

        .container {
          padding: 0 32px;
          background-color: #ffffff;
        }

        /* .card {
            background: #fff;
            border-radius: 16px;
            padding: 22px 18px;
            margin-bottom: 20px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        } */

        .title {
            text-align: center;
            font-size: 40px;
            font-weight: bold;
            color: #111;
            margin-bottom: 18px;
        }

        .tip-minor {
            background-color: #fff7e6;
            color: #d48806;
            padding: 10px 12px;
            border-radius: 10px;
            font-size: 24px;
            text-align: center;
            margin-bottom: 18px;
            font-weight: 500;
        }

        .subtitle {
            font-size: 32px;
            font-weight: bold;
            color: #00D9C5;
            margin: 32px 0 10px 0;
            padding-bottom: 16px;
            border-bottom: 1px solid #e6f7f5;
        }

        .list {
            padding-left: 12px;
            margin-top: 24px;
        }

        .list li {
            list-style: none;
            position: relative;
            padding-left: 32px;
            margin-bottom: 16px;
            font-size: 28px;
            color: #444;
            line-height: 44px;
        }

        .list li::before {
            content: "•";
            color: #00D9C5;
            font-weight: bold;
            position: absolute;
            left: 0;
            top: 0;
        }

        .warn {
            color: #ff4d4f;
            font-weight: 500;
        }

        .footer {
            text-align: center;
            font-size: 24px;
            color: #999;
            margin-top: 16px;
        }
</style>

<style src="../../styles/common.css" />
